import { usePopover } from '@deltasierra/react-hooks';
import { t } from '@deltasierra/shared';
import * as React from 'react';
import { DSPopover } from '../../mui/Popover';
import { DSIconButton } from '../../Generic/Buttons/DSIconButton';
import { Calendar } from '../../Calendar';

export interface DatePickerButtonProps {
    children?: React.ReactNode;
    icon?: JSX.Element;
    value?: Date;
    onChange?: (date?: Date) => void;
}

export function DatePickerButton(props: DatePickerButtonProps): JSX.Element {
    const [anchorEl, isOpen, { handleClose, handleToggle }] = usePopover<HTMLButtonElement>();
    const onChange = (date?: Date) => {
        props.onChange?.(date);
        handleClose({} as unknown as React.MouseEvent);
    };

    return (
        <>
            <DSIconButton
                aria-label={t('COMMON.OPEN_CALENDAR')}
                color={isOpen ? 'primary' : 'default'}
                size="small"
                onClick={handleToggle}
            >
                {props.icon}
            </DSIconButton>
            <DSPopover
                PaperProps={{ style: { marginTop: '16px' } }}
                anchorEl={anchorEl}
                anchorOrigin={{
                    horizontal: 'right',
                    vertical: 'bottom',
                }}
                open={isOpen}
                transformOrigin={{
                    horizontal: 'right',
                    vertical: 'top',
                }}
                onClose={handleClose}
            >
                <div style={{ maxWidth: '380px', padding: '12px' }}>
                    <Calendar selected={props.value} onSelectDate={onChange}>
                        <Calendar.MonthHeader />
                        <Calendar.Month />
                    </Calendar>
                </div>
            </DSPopover>
        </>
    );
}
DatePickerButton.displayName = 'DatePickerButton';
